import { render, staticRenderFns } from "./CardSetUser.vue?vue&type=template&id=6351f60a&scoped=true&"
import script from "./CardSetUser.vue?vue&type=script&lang=js&"
export * from "./CardSetUser.vue?vue&type=script&lang=js&"
import style0 from "./CardSetUser.vue?vue&type=style&index=0&id=6351f60a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351f60a",
  null
  
)

export default component.exports